<template>
  <div>
    <mdb-modal removeBackdrop centered @close="handleClose" elegant>
      <mdb-modal-header>
        <mdb-modal-title class="isi-heading-blue"
          >Test type mismatch</mdb-modal-title
        >
      </mdb-modal-header>
      <mdb-modal-body>
        <p class="mb-4 mt-n3">
          The test type of your search
          <strong>{{ searchTestTypeName }}</strong>
          does not match the test type of your request list
          <strong>{{ requestListTestTypeName }}</strong
          >.
          <br />
          <br />
          <template v-if="options.back"
            >You can either adjust the test type of your search, clear your
            request list to perform the search as it is or go back.</template
          >
          <template v-else
            >You can either adjust the test type of your search or clear your
            request list to perform the search as it is.</template
          >
        </p>
      </mdb-modal-body>
      <mdb-modal-footer class="d-flex justify-content-between">
        <mdb-btn
          v-if="options.adjustSearch"
          class="btn btn-isi-secondary"
          @click.native="adjustSearch"
          >Adjust Search</mdb-btn
        >
        <mdb-btn
          v-if="options.clearRequestList"
          class="btn btn-isi"
          @click.native="clearRequestList"
          >Clear Request List</mdb-btn
        >
        <mdb-btn
          v-if="options.back"
          class="btn btn-secondary"
          @click.native="$store.commit('clearCurrentModal')"
          >Back</mdb-btn
        >
      </mdb-modal-footer>
    </mdb-modal>
  </div>
</template>

<script>
import {
  mdbModal,
  mdbModalHeader,
  mdbModalTitle,
  mdbModalBody,
  mdbModalFooter,
  mdbBtn,
} from "mdbvue";

export default {
  components: {
    mdbModal,
    mdbModalHeader,
    mdbModalTitle,
    mdbModalBody,
    mdbModalFooter,
    mdbBtn,
  },
  data() {
    return {
      searchTestTypeName: this.$store.state.testTypes.find(
        (x) => x.id === this.options.searchParamsProxy.testType
      ).displayName,
      requestListTestTypeName: this.$store.state.testTypes.find(
        (x) => x.id === this.$store.state.user.requestList.testType
      ).displayName,
    };
  },
  props: {
    options: {
      type: Object,
      required: true,
    },
  },
  methods: {
    handleClose() {
      if (this.options.back) {
        this.$store.commit("clearCurrentModal");
      } else {
        this.adjustSearch();
      }
    },
    adjustSearch() {
      let searchParams = JSON.parse(
        JSON.stringify(this.options.searchParamsProxy)
      );
      searchParams.testType = this.$store.state.user.requestList.testType;
      this.$store.commit("setSearchParams", searchParams);
      this.$store.commit("clearCurrentModal");
    },
    clearRequestList() {
      this.$store.dispatch("clearRequestList", this.$http).then(() => {
        this.$store.commit("setSearchParams", this.options.searchParamsProxy);
        this.$store.commit("clearCurrentModal");
      });
    },
  },
};
</script>

<style>
</style>